export function trimEmptyLines(str) {
  if (typeof str !== 'string') return '';
  
  const lines = str
    .split('\n')
    .map(line => line.trim() === '' ? '' : line); // строки из пробелов → пустые строки
  
  // Удаление пустых строк в начале
  let start = 0;
  while (start < lines.length && lines[start] === '') {
    start++;
  }
  
  // Удаление пустых строк в конце
  let end = lines.length - 1;
  while (end >= 0 && lines[end] === '') {
    end--;
  }
  
  // Получаем строки без начальных и конечных пустых строк
  const trimmedLines = lines.slice(start, end + 1);
  
  // Нормализуем множественные пустые строки в одну
  const normalizedLines = [];
  let lastWasEmpty = false;
  
  for (const line of trimmedLines) {
    if (line === '') {
      if (!lastWasEmpty) {
        normalizedLines.push(line);
        lastWasEmpty = true;
      }
      // Пропускаем дополнительные пустые строки
    } else {
      normalizedLines.push(line);
      lastWasEmpty = false;
    }
  }
  
  return normalizedLines.join('\n');
}